import { createListReducer } from 'app/redux/reducers/_reducer-factory/createListReducer';

const TEMPLATE_NAME = 'CONFIGURATION_REPORT';

export default createListReducer(TEMPLATE_NAME);
